<template>
    <div class="calendar-app">
        <div class="app-calendar-main">
            <FullCalendar
                class="calendar-app-calendar"
                :options="calendarOptions"
                :plugins="calendarPlugins"
                :events="calendarEvents"
                @datesSet="handleDateChange"
                ref="fullCalendar"
            >
                <template v-slot:eventContent="arg">
                    <!-- <b>{{ arg.timeText }}</b> -->
                    <b v-html="arg.event.title"></b>
                </template>
            </FullCalendar>
        </div>

        <modal
            name="fullscreen-campaigne-modal"
            class="campaigne-modal"
            width="97%"
            height="95%"
            :adaptive="true"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('fullscreen-campaigne-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>

            <bo-marketing-emails-create
                :url_btn_campaigne_email_models="url_btn_campaigne_email_models"
                :url_btn_campaigne_index="url_btn_campaigne_index"
                :campaign_uuid="selectedCampaignUuid"
                :establishment="establishment"
            >
            </bo-marketing-emails-create>
        </modal>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import frLocale from '@fullcalendar/core/locales/fr'
import enLocale from '@fullcalendar/core/locales/en-gb'
import axios from 'axios'

export default {
    name: 'CampaingEmailCalender',
    props: ['url_btn_campaigne_email_models', 'url_btn_campaigne_index', 'establishment'],

    components: {
        FullCalendar, // make the <FullCalendar> tag available
    },

    data: function () {
        return {
            popupShow: false,

            isLoading: false,

            calendarEvents: [],

            showModal: false,
            selectedSlotData: {},

            startCalender: '',
            endCalender: '',

            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                headerToolbar: {
                    left: 'today,prev,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay',
                    // right: 'prev,next',
                },
                initialView: 'dayGridMonth',
                locale: this.$i18n.locale === 'fr' ? frLocale : enLocale,
                events: this.fetchEvents,
                // eventColor: '#000',
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                dateClick: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                datesSet: this.handleDateChange,

                /* you can update a remote database when these fire:
                    eventAdd:
                    eventChange:
                    eventRemove:
                */
            },
            calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            currentEvents: [],
            prestation: null,
            showAll: false,
            URLs: {},
            mode: 'create',
            preDataInit: {
                start: null,
                end: null,
            },
            canEditTime: true,
            selectedCampaignUuid: '',
        }
    },

    methods: {
        closeModal() {
            this.$modal.hide('fullscreen-campaigne-modal')
            this.showModal = false
        },

        setPreDataInit(start, end) {
            this.preDataInit.start = start
            this.preDataInit.end = end
        },

        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },

        handleDateSelect(selectInfo) {
            this.mode = 'create'
            this.startCalender = selectInfo.dateStr
            this.endCalender = selectInfo.dateStr

            // Access the selected slot's information
            const selectedSlot = {
                start: selectInfo.dateStr,
                end: selectInfo.dateStr,
                allDay: selectInfo.allDay,
            }

            this.selectedSlotData = selectedSlot // Update the data property
        },

        handleEventClick(clickInfo) {
            this.mode = 'edit'
            console.log('handleEventClick', clickInfo.event.extendedProps.uuid)
            this.selectedCampaignUuid = clickInfo.event.extendedProps.uuid

            this.$modal.show('fullscreen-campaigne-modal')
        },

        handleEvents(events) {
            this.currentEvents = events
        },

        handleDateChange(info) {
            const start = info.startStr
            const end = info.endStr
            // this.refreshCalendar()
        },

        fetchCampaigns(start, end) {
            return axios.get(`/back-office/campaigne-emails/calender`, {
                params: {
                    start,
                    end,
                    ajax: true,
                },
            })
        },

        async fetchEvents(fetchInfo, successCallback, failureCallback, refresh = false) {
            var start = (this.startCalender = fetchInfo?.startStr ?? this.startCalender)
            var end = (this.endCalender = fetchInfo?.endStr ?? this.endCalender)
            try {
                await this.getEvents(start, end)
                if (typeof successCallback === 'function') {
                    // Pass the events to FullCalendar's successCallback
                    successCallback(this.calendarEvents)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        refreshCalendar() {
            // console.log('refreshCalendar ..')
            this.calendarEvents = []
            this.fetchEvents() // Fetch new events

            setTimeout(() => {
                const calendarRef = this.$refs.fullCalendar

                if (calendarRef) {
                    calendarRef.getApi().refetchEvents()
                }
            }, 100)
        },
        async getEvents(start, end) {
            this.isLoading = true

            try {
                let response = await this.fetchCampaigns(start, end)
                this.calendarEvents = response.data.data.map((event) => ({
                    id: event.id,
                    uuid: event.uuid,
                    title: event.title,
                    start: event.start_date_time,
                    end: event.end,
                    color: '#fff',
                    backgroundColor: '#7D2DBD',
                }))

                this.isLoading = false
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.isLoading = false
                // failureCallback(error)
                throw new Error('Error fetching events')
            }
        },
        /**
         *
         * @param {String} date
         * point the calendar view in a specific date.
         */
        gotToDate(date) {
            this.$refs.fullCalendar.getApi().gotoDate(date)
            setTimeout(() => {
                const calendarRef = this.$refs.fullCalendar
                if (calendarRef) {
                    calendarRef.getApi().refetchEvents()
                }
            }, 1000)
        },
    },

    async mounted() {
        // await this.init()
    },
}
</script>

<style scoped lang="css">
h2 {
    margin: 0;
    font-size: 16px;
}

ul {
    margin: 0;
    padding: 0 0 0 1.5em;
}

li {
    margin: 1.5em 0;
    padding: 0;
}

b {
    /* used for event dates/times */
    margin-right: 3px;
}

.calendar-app {
    display: flex;
    min-height: 100%;
    font-family:
        Arial,
        Helvetica Neue,
        Helvetica,
        sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
}

.calendar-app-sidebar {
    width: 300px;
    line-height: 1.5;
    background: #eaf9ff;
    border-right: 1px solid #d3e2e8;
}

.calendar-app-sidebar-section {
    padding: 2em;
}

.app-calendar-main {
    flex-grow: 1;
    padding-top: 3em;
    padding-bottom: 3em;
}

.fc {
    /* the calendar root */
    max-width: 1100px;
    margin: 0 auto;
}

/* Default styles */
.modal {
    width: 60%; /* Or any default width */
}

/* Media query for smaller screens */
@media (max-width: 768px) {
    .modal {
        width: 90%; /* Adjust width for smaller screens */
    }
}

.fc .fc-daygrid-event-harness {
    height: 100% !important;
    background: #517db3;
}

.campaigne-modal {
    overflow-y: auto;
    height: calc(100% - 50px);
}

.vm--modal {
    background-color: #f8fafc !important;
    padding: 1rem !important;
}

.btn-exit {
    position: absolute;
    top: 7px;
    right: 7px;
    display: flex;
    width: 45px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 15px;
}
</style>
